import { render, staticRenderFns } from "./Devices.vue?vue&type=template&id=3bcb1be2&scoped=true&lang=pug&"
import script from "./Devices.vue?vue&type=script&lang=js&"
export * from "./Devices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcb1be2",
  null
  
)

export default component.exports